import { Component, OnInit } from '@angular/core';

// Service
import { ApiService } from '../../shared/service/api.service';
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styles: [
  ]
})
export class ProductComponent implements OnInit {

  dataBanner;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.apiService.getDataApi('getSubHeaderByLink/our-products').subscribe(response => {
        this.dataBanner = response.data;
    });
  }

}
